import React from "react";
import { Sparkles, Flame, Users, Expand } from "lucide-react";

const milestones = [
  { icon: Flame,   title: "2020 — Where it started", note: "Opened the studio with a single Glowforge machine, strictly engraving plaques." },
  { icon: Expand,  title: "Expanded capabilities",     note: "Grew into multiple machines and a wide range of materials — wood, metal, slate, leather and more." },
  { icon: Sparkles,title: "Memorials, celebrations, personal items", note: "Engraved for moments that matter — tributes, milestones, gifts and everyday keepsakes." },
  { icon: Users,   title: "Families from all over",  note: "Served customers across the country and we're excited to serve every new one that comes our way." },
];

export default function About() {
  return (
    <div data-testid="about-page" className="max-w-5xl mx-auto px-6 lg:px-10 py-16">
      <div className="uppercase text-xs tracking-[0.3em] font-bold" style={{color: "var(--secondary)"}}>About</div>
      <h1 className="font-serif text-5xl sm:text-6xl mt-3 leading-tight" style={{color: "var(--primary)"}}>A small studio, built laser-pass by laser-pass.</h1>

      <div className="mt-10 grid md:grid-cols-5 gap-10">
        <div className="md:col-span-3">
          <div className="rounded-lg overflow-hidden border hairline shadow-[0_8px_30px_rgba(44,53,57,0.15)]">
            <img data-testid="about-hero-img" src="/laser-engraver.png" alt="Laser engraving a walnut plaque in the studio" className="w-full h-auto block"/>
          </div>
        </div>

        <div className="md:col-span-2 space-y-5 text-[color:var(--text-main)] leading-relaxed">
          <p>EZ JEM Designs began in <span className="font-semibold" style={{color: "var(--primary)"}}>2020</span> with a single Glowforge machine, strictly engraving plaques. Over the years we've grown into multiple machines and expanded into all sorts of engraving on a wide variety of materials.</p>
          <p>We've engraved for <span className="font-semibold" style={{color: "var(--primary)"}}>memorials, celebrations, and personal items</span> — and we're always expanding our capabilities so there's rarely a project we won't take on.</p>
          <p>We've served families from all over and we're genuinely excited to serve every new customer that comes our way.</p>
        </div>
      </div>

      {/* STORY TIMELINE */}
      <div className="mt-20">
        <div className="uppercase text-xs tracking-[0.3em] font-bold" style={{color: "var(--secondary)"}}>Our story</div>
        <h2 className="font-serif text-4xl mt-3" style={{color: "var(--primary)"}}>Four passes that shaped who we are.</h2>
        <div className="grid md:grid-cols-2 gap-6 mt-10">
          {milestones.map((m) => (
            <div key={m.title} data-testid={`milestone-${m.title.split(" ")[0].toLowerCase()}`} className="rounded-lg border hairline p-6 bg-white card-lift flex gap-4">
              <div className="shrink-0 w-11 h-11 rounded-full flex items-center justify-center" style={{background: "rgba(197,160,89,0.14)", color: "var(--accent-metal)"}}>
                <m.icon size={18} strokeWidth={1.75}/>
              </div>
              <div>
                <div className="font-serif text-xl" style={{color: "var(--primary)"}}>{m.title}</div>
                <div className="mt-1 text-sm text-[color:var(--text-muted)] leading-relaxed">{m.note}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* PROMISE */}
      <div className="mt-20 rounded-lg border hairline p-10 text-center" style={{background: "linear-gradient(135deg, rgba(197,160,89,0.08), rgba(74,43,22,0.03))"}}>
        <div className="uppercase text-xs tracking-[0.3em] font-bold" style={{color: "var(--accent-metal)"}}>Our promise</div>
        <h3 className="font-serif text-3xl sm:text-4xl mt-3 max-w-2xl mx-auto" style={{color: "var(--primary)"}}>If we can lase it, we can personalize it.</h3>
        <p className="mt-4 text-sm text-[color:var(--text-muted)] max-w-xl mx-auto leading-relaxed">
          Reach out with your idea — even if your material isn't on our list, chances are we can source it or already work with something similar.
        </p>
      </div>
    </div>
  );
}
